import type { PaletteColor } from '@mui/material/styles/createPalette';

import type { ColorPreset } from '.';

import { blue, green, indigo, purple } from './colors';

export const getPrimary = (preset?: ColorPreset): PaletteColor => {
  if (!preset) return blue;

  switch (preset) {
    case 'blue':
      return blue;
    case 'green':
      return green;
    case 'indigo':
      return indigo;
    case 'purple':
      return purple;
    default:
      return blue;
  }
};
